import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=1d808bce&scoped=true&"
import script from "./planList.vue?vue&type=script&lang=js&"
export * from "./planList.vue?vue&type=script&lang=js&"
import style0 from "./planList.vue?vue&type=style&index=0&id=1d808bce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d808bce",
  null
  
)

export default component.exports